/**
 * スタンバイ中のガチャのスワイパー
 * 左から右にスワイプすることでガチャ動画を再生する
 */

import { Box, styled } from '@mui/material'
import { FC, useEffect, useState } from 'react'
import { useSwipeable } from 'react-swipeable'
import { Fade, SwipeGuide } from 'utoniq-ui'

import { isMobileDevice } from '@/components/styles'

export const StandbyTrigger: FC<{
  onPlay: () => void
}> = ({ onPlay }) => {
  const handlers = useSwipeable({
    onSwipedRight: onPlay,
    trackMouse: !isMobileDevice(),
    delta: 120,
  })
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    if (!mounted) {
      setTimeout(() => {
        setMounted(true) // 0.5秒後に表示
      }, 500)
    }
  }, [mounted])

  if (!mounted) return null

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        backgroundColor: 'transparent',
        position: 'absolute',
        top: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        maxWidth: '600px',
        zIndex: 11,
        pointerEvents: 'none',
        px: '7.5%',
        py: '80px',
      }}
    >
      <Box
        sx={{
          height: '100%',
          display: 'grid',
          placeItems: 'center',
          pointerEvents: 'auto',
        }}
        {...handlers}
      >
        <Fade in timeout={300}>
          <AnimationWrapper>
            <SwipeGuide
              iconProps={{
                sx: {
                  width: 115,
                  height: 115,
                  position: 'relative',
                  left: '-70px',
                  top: '16px',
                },
              }}
            />
          </AnimationWrapper>
        </Fade>
      </Box>
    </Box>
  )
}

const AnimationWrapper = styled('div')({
  animation: 'axis 2s infinite linear',
  '@keyframes axis': {
    '0%': {
      transform: 'translateX(0) translateY(0)',
      opacity: 0,
    },
    '10%': {
      transform: 'translateX(0) translateY(0)',
    },
    '15%': {
      opacity: 1,
    },
    '20%': {
      transform: 'translateX(-25px) translateY(-25px)',
      opacity: 1,
    },
    '25%': {
      transform: 'translateX(-30px) translateY(-28px)',
      opacity: 1,
    },
    '30%': {
      transform: 'translateX(-30px) translateY(-30px)',
      opacity: 1,
    },
    '50%': {
      transform: 'translateX(130px) translateY(-40px)',
    },
    '60%': {
      transform: 'translateX(130px) translateY(-40px)',
      opacity: 0.5,
    },
    '75%': {
      transform: 'translateX(130px) translateY(-40px)',
      opacity: 0,
    },
    '100%': {
      transform: 'translateX(130px) translateY(-40px)',
      opacity: 0,
    },
  },
}) as typeof Box
